import React from 'react';

interface IconLogoutProps {
    width?: number;
    height?: number;
    color?: string;
    opacity?: number;
}

const IconLogout: React.FC<IconLogoutProps> = ({
    width = 21,
    height = 21,
    color = 'black',
    opacity = 0.7,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 21 21"
            fill="none"
        >
            <g clipPath="url(#clip0_9406_12379)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1282 17.3146V18.3114C10.1282 19.1107 9.72985 19.8007 9.03762 20.2003C8.70458 20.3926 8.33286 20.4998 7.94747 20.5C7.56172 20.5002 7.19012 20.3928 6.85684 20.2003L2.42497 17.6416C1.73266 17.2419 1.33438 16.552 1.33438 15.7526V2.68117C1.33438 1.4784 2.31282 0.5 3.51555 0.5H13.2761C14.479 0.5 15.4575 1.47832 15.4575 2.68117V5.4366C15.4575 5.83187 15.1365 6.15281 14.7413 6.15281C14.3459 6.15281 14.0252 5.83191 14.0252 5.4366V2.68117C14.0252 2.26816 13.6891 1.93211 13.2761 1.93211H4.72333L9.03762 4.4234C9.72962 4.82301 10.1282 5.51285 10.1282 6.31195V15.8824H13.2761C13.6891 15.8824 14.0252 15.5465 14.0252 15.1335V12.718C14.0252 12.3225 14.3457 12.0018 14.7413 12.0018C15.1367 12.0018 15.4575 12.3225 15.4575 12.718V15.1335C15.4575 16.3363 14.479 17.3146 13.2761 17.3146H10.1282ZM16.7643 9.62336L15.9756 10.4121C15.6959 10.6917 15.696 11.1451 15.9756 11.4248C16.1102 11.5595 16.2916 11.6343 16.4819 11.6343C16.6725 11.6343 16.8537 11.5596 16.9885 11.4248L18.9994 9.41352C19.279 9.13391 19.279 8.68078 18.9994 8.40117L16.9885 6.39023C16.7088 6.11055 16.2554 6.11066 15.9756 6.3902C15.696 6.66957 15.6961 7.12312 15.9756 7.40258L16.7643 8.19109H11.4807C11.085 8.19109 10.7646 8.51172 10.7646 8.90734C10.7646 9.30297 11.085 9.6234 11.4807 9.6234H16.7643V9.62336Z"
                    fill={color}
                    fillOpacity={opacity}
                />
            </g>
            <defs>
                <clipPath id="clip0_9406_12379">
                    <rect width="20" height="20" fill="white" transform="translate(0.271729 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconLogout;
